module.exports = __webpack_public_path__ + "static/handoff-984ddb1ad7b390f9211330b561a08086.png";